import store from '../../store';
import cookieManagerHelper from 'Helpers/cookies';
import { hats } from 'Actions/hats';

function getHaTSCookie() {
    const hatsCookie = cookieManagerHelper.readCookie('HaTS');
    const hatsAvailable = !(hatsCookie && hatsCookie !== 'undefined' && typeof hatsCookie !== 'undefined');

    store.dispatch(hats(hatsAvailable));
    return hatsAvailable;
}

function setHaTSCookie() {
    const expirationDays = 180;

    store.dispatch(hats(true));
    cookieManagerHelper.createCookie('HaTS', true, expirationDays);
}

export {
    getHaTSCookie,
    setHaTSCookie
};

